import { ItemSource } from '../../../models/queries/queries.models';
export class ItemsourceFilterValueConverter {
    toView(value, filterFunc) {
        const gridItems: ItemSource = value;
        
        if(gridItems && gridItems.source){
            gridItems.source = filterFunc(gridItems.source);
        }
        return gridItems;
    }

    fromView(value) {
        return value;
    }
}